<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bxXeb8/images/buried-secrets.jpg?1733151169100" alt="This image is the cover for the book Buried Secrets, East Rise"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Buried Secrets, East Rise
      </h1>
      <p class="bookDescription body article font2">
        <b>A DI’s secrets come under scrutiny as his police colleagues investigate his wife’s murder, in this shocking new thriller by the author of <i>Mercy Killing</i> . . .</b><br/><br/> DI Milton Bowman’s morning commute takes a tragic turn when he’s involved in a serious car accident and is taken to the hospital. DI Harry Powell, a close friend and coworker, goes to break the news to Bowman’s wife, Linda—only to discover she’s been murdered.<br/><br/> As the team, including DC Hazel Hamilton, delves into the investigation, every facet of Bowman’s life comes under scrutiny. Suspicion and shock ripple through the ranks as they uncover a web of deceit that has ensnared them all for years. Trust is shattered, and everyone is a suspect—the Bowman family, friends, colleagues, and even Harry Powell himself. In this tangled mystery that draws from the author’s twenty-five years of police work, nothing is as it seems—and no one is telling the whole truth.<br/><br/><b>Praise for the novels of Lisa Cutts</b><br/><br/> “Utterly gripping and hauntingly realistic.” —Lisa Hall, author of <i>Between You and Me</i><br/><br/> “Brutal, harrowing and compelling . . . challenges everything you thought you knew about police investigations.” —Elizabeth Haynes, author of <i>Into the Darkest Corner</i><br/><br/> “A genuinely immersive read.” —Kate Rhodes, author of <i>Fatal Harmony</i><br/><br/> “A smart, compulsive police procedural . . . superbly and entertainingly told.” —Louise Candlish, author of <i>The Other Passenger</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa Cutts
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?618c3b42